/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Coverage_Item2Inputs */

const ja_playdata_about_coverage_item2 = /** @type {(inputs: Playdata_About_Coverage_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海外公式プロリーグおよび大会の日本語放送`)
};

const en_playdata_about_coverage_item2 = /** @type {(inputs: Playdata_About_Coverage_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanese broadcasts of overseas official leagues and competitions`)
};

/**
* | output |
* | --- |
* | "Japanese broadcasts of overseas official leagues and competitions" |
*
* @param {Playdata_About_Coverage_Item2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_coverage_item2 = /** @type {((inputs?: Playdata_About_Coverage_Item2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Coverage_Item2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_coverage_item2(inputs)
	return en_playdata_about_coverage_item2(inputs)
});